module.exports = __webpack_public_path__ + "img/top-image.f94987a9.png";